declare global {
  interface Window {
    hj: any;
  }
}

const isHotJarDefined = () =>
  typeof window !== 'undefined' && typeof window.hj === 'function';

let retries = 0;

export const hotjarEvent = (value: string, delay = 0): void => {
  if (!isHotJarDefined() && retries <= 2) {
    setTimeout(() => {
      retries++;
      hotjarEvent(value, delay);
    }, 1000);
  } else if (isHotJarDefined()) {
    setTimeout(() => {
      window.hj('event', value);
    }, delay);
  }
};
